import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/css/common.css'


import * as ElementPlusIconsVue from '@element-plus/icons-vue'
 
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router).use(Vant).use(ElementPlus).mount('#app')


